import { rankCol, playerCol, divCol, teamCol, confCol, yearCol, round1Col, numCol, warCol, sosAdjWarCol } from "./helpers";

const valueStats = [
  round1Col("WPA", "wpa"),
  round1Col("+WPA", "pos_wpa"),
  round1Col("-WPA", "neg_wpa"),
  round1Col("RE24", "rea"),
  round1Col("REW", "rew"),
  round1Col("pLI", "pli"),
  round1Col("WPA/LI", "wpa_li"),
  round1Col("Clutch", "clutch"),
];

export const getValueBatterColumns = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  warCol(), sosAdjWarCol(),
  ...valueStats,
];

export const getValuePitcherColumns = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  warCol(), sosAdjWarCol(),
  ...valueStats,
];

export const columnsValueBattingTeam = [
  rankCol(), teamCol(), confCol(), divCol(), yearCol(),
  warCol(), sosAdjWarCol(),
  ...valueStats,
];

export const columnsValuePitchingTeam = [
  rankCol(), teamCol(), confCol(), divCol(), yearCol(),
  warCol(), sosAdjWarCol(),
  ...valueStats,
  numCol("Pulls", "pitching_changes"),
];
